import { Communities } from './services/communities.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';

import { Routing } from './app.routes';
import { LayoutComponent } from './layout/layout.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { BoardComponent } from './board/board.component';
import { PostitComponent } from './postit/postit.component';

import { CreateBoardComponent } from './create-board/create-board.component';
import { CreateBoardSpacesComponent } from './create-board-spaces/create-board-spaces.component';

// Services
import { ApiService } from './services/api.service';
import { LocalStorageService } from './services/localstorage.service';
import { SharedService } from './services/shared.service';
import { KeyContents } from './services/keycontents.service';

// Guards
import { AuthGuard } from './guards/auth.guard';
import { RedirectGuard } from './guards/redirect.guard';
import { ConnectComponent } from './connect/connect.component';

import { ContentComponent } from './contents/contents.component';


@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    NotFoundComponent,
    BoardComponent,
    CreateBoardComponent,
    CreateBoardSpacesComponent,
    ConnectComponent,
    PostitComponent,
    ContentComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    Routing,
    FormsModule,
    HttpModule,
  ],
  providers: [
    ApiService,
    AuthGuard,
    KeyContents,
    RedirectGuard,
    LocalStorageService,
    SharedService,
    Communities
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/app.module.ts